import * as React from 'react';

import { IScrollingContext } from '../../types/page/scrolling';

const defaultScrollingContext: IScrollingContext = {
  refBlocksState: {},
  setRefBlocksState: () => null,
};

export const scrollingContext = React.createContext(defaultScrollingContext);

export const Provider = scrollingContext.Provider;
